<template>
	<div class="full page_container">
		<el-tabs class="tabs flex" v-model="activeName" type="border-card">
			<el-tab-pane label="流量" name="flow" style="height: 100%;">
				<flow-index v-if="activeName=='flow'" />
			</el-tab-pane>
			<el-tab-pane label="销售目标" name="goodskpi" style="height: 100%;">
				<goodskpi-index v-if="activeName=='goodskpi'" />
			</el-tab-pane>
			<el-tab-pane label="商品新" name="goodsnew" style="height: 100%;">
				<goodsnew-index v-if="activeName=='goodsnew'" />
			</el-tab-pane>
		</el-tabs>
	</div>
</template>
<style scoped>
	.departmen_container {
		padding: 10px;
		box-sizing: border-box;
		flex-direction: column;
	}

	.tabs {
		flex-direction: column;
		position: relative;
		width: 100%;
		height: 100%;
	}
</style>
<script>
	import flowIndex from './flow/index.vue'
	import goodskpiIndex from './goodskpi/index.vue'
	import goodsnewIndex from './goodsnew/index.vue'
	export default {
		props: {

		},
		data() {
			return {
				activeName: 'goodskpi',
				activeIndex: '',
				departmentChildren: [],

			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {

		},
		components: {
			flowIndex,
			goodskpiIndex,
			goodsnewIndex
		}
	}
</script>